import React, { useCallback, useEffect } from "react";
import { touched } from "../../../containers/ActivityList/ActivityService";
import { PasswordInput } from "./FormInput";
import { FieldControl, FormControl } from "react-reactive-form";
import { FormGroups } from "../../ReusableComponents/FormGroups/FormGroups";

const PasswordUI = ({ form, keyName, label, get,placeholder,errorText }) => {
  const temp = "show_" + keyName;
  useEffect(() => {
    form.addControl([temp], new FormControl(false));
  }, []);
  const showPasswords = useCallback(() => {
    form.patchValue({ [temp]: !form.value[temp] });
    touched(keyName, form);
  }, [form, keyName, temp, touched]);
  return (
    <FormGroups>
      <FieldControl
        name={keyName}
        render={PasswordInput}
        meta={{
          showPasswordKey: temp,
          get: get,
          show: true,
          showPasswords: showPasswords,
          label: label,
          type: "password",
          minLength: "10",
          maxLength: "50",
          placeholder: placeholder || "",
          errorText: errorText || undefined,
          valid: false,
        }}
      />
    </FormGroups>
  );
};

export default PasswordUI;
